import { type ComponentType } from 'react';

import { Loader } from '../loader/loader';

export const withSpinnerLoaderComponent = <T,>(Component: ComponentType<T>, props: T) => (
  <Component {...props} LoaderComponent={Loader} />
);
